import React, { useEffect } from 'react';
import { useField } from 'informed';

interface ConditionallyDependentFieldProps {
  field: string;
  values: any;
  dependentOnFields?: string[];
  conditionallyDependentValues?: Array<{
    condition: string;
    value: string | boolean;
    isConditionalValue?: boolean;
  }>;
}

export const ConditionallyDependentField = (
  props: ConditionallyDependentFieldProps
): null => {
  const { field, values, dependentOnFields, conditionallyDependentValues } =
    props;

  const { fieldApi } = useField({
    field,
    validateOnBlur: false,
    validateOnChange: false,
    error: '',
    touched: false
  });

  const isDependentFieldValueChanged = (): boolean => {
    return dependentOnFields.some((field) => {
      return values[field];
    });
  };

  const setConditionallyDependentFieldValue = (): void => {
    conditionallyDependentValues.forEach((conditionalValues) => {
      if (eval(conditionalValues.condition)) {
        if (conditionalValues.isConditionalValue) {
          fieldApi.setValue(eval(conditionalValues.value as string));
        } else fieldApi.setValue(conditionalValues.value);
      }
    });
  };

  useEffect(() => {
    if (isDependentFieldValueChanged()) {
      setConditionallyDependentFieldValue();
    }
  }, [...dependentOnFields.map((field) => values[field])]);

  return null;
};
